<template>
  <button
    type="button"
    class="input-item"
    v-on="$listeners">
    {{ condition.unit }}
  </button>
</template>

<script>
export default {
  props: {
    condition: {
      type: Object,
      default: null
    },
  },
}
</script>

<style lang="scss" scoped>
.input-item {
  background: none;
  color: $l-blue;
  border: none;
  width: 100%;
  height: 100%;
  text-align: center;
  text-align-last: center;
  white-space: nowrap;
}
</style>